import { NamedItemInt, NamedItemString, PagedFilter } from '../../../index'
import { adminHttpClient } from '../../commons/adminHttpClient'
import PagedList from '../../commons/pagedList'

export type KeywordResponse = {
  keywordId: string
  keyword: string
  status: NamedItemInt
  type: NamedItemInt
  expenseTypes: NamedItemInt[]
  exceptions: NamedItemString[]
}

export type KeywordForSaveResponse = {
  keywordId: string
  keyword: string
  status: number
  type: number
  expenseTypes: number[]
  exceptions: string[]
  availableExpenseTypes: NamedItemInt[]
}

export type KeywordForSaveRequest = {
  keywordId: string | null
  keyword: string
  status: number
  expenseTypes: number[]
  exceptions: string[]
  Type: number
}

const getAllKeywords = (request: PagedFilter): Promise<PagedList<KeywordResponse>> =>
  adminHttpClient.get('DocReview/GetAllKeywords', request)

export const getKeywordForSave = (request: string | null): Promise<KeywordForSaveResponse> =>
  adminHttpClient.get(`DocReview/KeywordForSave`, { keywordId: request })

export const saveKeyword = (request: KeywordForSaveRequest): Promise<any> => {
  return adminHttpClient.put('/DocReview/SaveKeyword', request)
}

export const deleteKeyword = (keywordId: string): Promise<any> => {
  return adminHttpClient.delete(`/DocReview/DeleteKeyword`, { data: { keywordId: keywordId } })
}

export default getAllKeywords
